import { DEFAULT_FONTFAMILY, DARK_BLUE_COLOR } from 'theme/theme';
import { CALENDAR_Z_INDEX } from 'theme/zIndex';
import { FOCUS_OUTLINE } from 'theme/focus';

const SELECTABLE_AREA_HEIGHT = 200;
const SELECTED_BG_COLOR = '#A9431E';
const NOW_BG_COLOR = '#DDB4A5';
const FONT = `400 14px/18px ${DEFAULT_FONTFAMILY}`;
const VIEW_PADDING = [10, 15];
const tileActive = {
  backgroundColor: SELECTED_BG_COLOR,
  border: `2px solid ${SELECTED_BG_COLOR}`,
  color: '#FFF',
  outline: 'none',
};

export default {
  'CalendarWrapper': {
    position: 'relative',
  },
  'react-calendar': {
    boxShadow: '0 2px 5px 0px rgba(0, 0, 0, 0.21)',
    minWidth: 300,
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: CALENDAR_Z_INDEX,
    backgroundColor: '#FFF',
  },
  '@global .position-top .react-calendar': {
    top: 'unset',
    bottom: 35,
  },
  navigation: {
    height: 46,
    backgroundColor: SELECTED_BG_COLOR,
    color: '#FFF',
    '&__arrow': {
      flex: '0 0 30px',
      color: '#FFF',
      font: FONT,
      '&:focus': {
        outline: `2px solid ${FOCUS_OUTLINE}`,
      },
    },
    '&__arrow[disabled]': {
      opacity: 0.5,
    },
    '&__label': {
      color: '#FFF',
      font: FONT,
      '&:focus': {
        outline: `2px solid ${FOCUS_OUTLINE}`,
      },
    },
  },
  'month-view': {
    padding: VIEW_PADDING,
    font: FONT,
    '&__days': {
      minHeight: SELECTABLE_AREA_HEIGHT,
      // fix IE11 flex align-items: stretch to work correctly
      height: Math.floor(SELECTABLE_AREA_HEIGHT / 2),
    '&__days__day--neighboringMonth': {
      opacity: 0.35,
    },
    },
    '&__days__day[disabled]': {
      opacity: 0.5,
    },
    '&__weekdays': {
      paddingTop: 5,
      height: 28,
    },
    '&__weekdays__weekday': {
      textAlign: 'center',
    },
  },
  'year-view': {
    padding: VIEW_PADDING,
    font: FONT,
    '&__months': {
      minHeight: SELECTABLE_AREA_HEIGHT,
      // fix IE11 flex align-items: stretch to work correctly
      height: Math.floor(SELECTABLE_AREA_HEIGHT / 2),
    },
    '&__months__month[disabled]': {
      opacity: 0.5,
    },
  },
  'decade-view': {
    padding: VIEW_PADDING,
    font: FONT,
    '&__years': {
      minHeight: SELECTABLE_AREA_HEIGHT,
      // fix IE11 flex align-items: stretch to work correctly
      height: Math.floor(SELECTABLE_AREA_HEIGHT / 2),
    },
    '&__years__year[disabled]': {
      opacity: 0.5,
    },
  },
  'century-view': {
    padding: VIEW_PADDING,
    font: FONT,
    '&__decades': {
      minHeight: SELECTABLE_AREA_HEIGHT,
      // fix IE11 flex align-items: stretch to work correctly
      height: Math.floor(SELECTABLE_AREA_HEIGHT / 2),
    },
    '&__decades__decade[disabled]': {
      opacity: 0.5,
    },
  },
  tile: {
    font: FONT,
    border: '2px solid #FFF',
    '&--now': {
      backgroundColor: NOW_BG_COLOR,
      border: `2px solid ${NOW_BG_COLOR}`,
      color: '#FFF',
      outline: 'none',
    },
    '&--hasActive': tileActive,
    '&--active': tileActive,
    '&:hover': {
      backgroundColor: '#FFF',
      border: `2px solid ${SELECTED_BG_COLOR}`,
      color: DARK_BLUE_COLOR,
    },
    '&:focus': {
      backgroundColor: '#FFF',
      border: `2px solid ${SELECTED_BG_COLOR}`,
      color: DARK_BLUE_COLOR,
      outline: 'none',
    },
    '&--active:focus': {
      extend: tileActive,
    },
    '&--active:hover': {
      extend: tileActive,
    },
  },
};
